import React from 'react';
import { connect } from 'react-redux';
import PostbackTest from './PostbackTest.js';
import { actions } from './PostbackTest.actions';

const PostbackTestComponent = connect(
    function mapStateToProps(state) {
        return {
            modalIsVisible: state.postbackTest.modalIsVisible,
            loadingSave: state.postbacks.loadingSave,
            saveSuccess: state.postbacks.saveSuccess,
            loading: state.postbackTest.loading,
            data: state.postbackTest.data
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            visibleModal: actions.visibleModal,
            hiddenModal: actions.hiddenModal,
            testing: actions.testing,
            clear: actions.clear
        };
    }
)(PostbackTest);

export default PostbackTestComponent;
